import { render } from "./AiPortalManageView.vue?vue&type=template&id=dac2b8ae&scoped=true&ts=true"
import script from "./AiPortalManageView.vue?vue&type=script&lang=ts"
export * from "./AiPortalManageView.vue?vue&type=script&lang=ts"

import "./AiPortalManageView.vue?vue&type=style&index=0&id=dac2b8ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac2b8ae"]])

export default __exports__